function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "1072,272 1072,623.998 976,623.998 976,272 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "336,239.999 1712,239.999 1712,335.999 336,335.999 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1664 797.471c0,-60.9378 -24.9071,-116.315 -65.0327,-156.441 -40.1256,-40.1256 -95.5028,-65.0327 -156.441,-65.0327l-370.529 0 -96.0001 0 -370.527 0c-60.9378,0 -116.315,24.9071 -156.441,65.0327 -40.1256,40.1256 -65.0327,95.5028 -65.0327,156.441l0 773.056c0,60.9378 24.9071,116.315 65.0327,156.441 40.1256,40.1256 95.5028,65.0327 156.441,65.0327l837.056 0c60.9378,0 116.315,-24.9071 156.441,-65.0327 40.1256,-40.1256 65.0327,-95.5028 65.0327,-156.441l0 -773.056zm-608.001 34.5284l470.738 0c20.1142,0 38.4237,8.25119 51.717,21.5445 13.2933,13.2933 21.5445,31.6028 21.5457,51.717l-0.0011811 429.476c0,20.1142 -8.25119,38.4237 -21.5445,51.717 -13.2933,13.2933 -31.6028,21.5445 -51.717,21.5445l-470.738 0 0 -575.999zm-534.74 0l470.738 0 0 575.999 -470.738 0c-20.1142,0 -38.4237,-8.25119 -51.717,-21.5445 -13.2012,-13.2012 -21.4299,-31.35 -21.5433,-51.3l0 -0.0779528 0 -430.154 0 -0.0779528c0.113386,-19.95 8.34213,-38.0988 21.5433,-51.3 13.2933,-13.2933 31.6028,-21.5445 51.717,-21.5445z"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  width: 2048,
  height: 2048
});

var SvgCableCar = function SvgCableCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "2048px",
    height: "2048px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2048 2048",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCableCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CableCar.e69c3c7b.svg";
export { ForwardRef as ReactComponent };